import { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import Loading from './Loading.js';

const moment = require('moment');

class TreasurerReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      isLoading     :true,
      sortColumn: null,
      sortDirection: null,
    };
    this.getTreasurerReports = this.getTreasurerReports.bind(this);
  }

  async getTreasurerReports() {
    try {

      const response = await fetch('/api/treasurer_reports');
      const json = await response.json();
      console.log(json);
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getTreasurerReports();
  }

  handleSort(column) {
    const { sortColumn, sortDirection } = this.state;
    let newDirection = 'asc';
    if (sortColumn === column && sortDirection === 'asc') {
      newDirection = 'desc';
    } else if (sortColumn === column && sortDirection === 'desc') {
      newDirection = null; // Remove sorting when clicking thrice
    }
    this.setState({ sortColumn: column, sortDirection: newDirection });
  }

  getSortedData() {
    const { data, sortColumn, sortDirection } = this.state;
  
    // If there's no sortColumn or sortDirection, return the data as is
    if (!sortColumn || !sortDirection) {
      return data;
    }
  
    // Sort data based on the sortColumn and sortDirection
    const sortedData = [...data].sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) {
        return sortDirection === 'asc' ? -1 : 1;
      }
      if (a[sortColumn] > b[sortColumn]) {
        return sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  
    return sortedData;
  }


  render() {
    if(!this.state.isLoading){
      const sorted_treasurer_reports = this.getSortedData();
      const treasurer_reports_list = sorted_treasurer_reports.map((treasurer_report)=>
          <tr key={treasurer_report.id} id={treasurer_report.id}>
              <td>{moment(treasurer_report.created_date).format('l')}</td>
              <td>{treasurer_report.title}</td>
              <td>{treasurer_report.posted_by}</td>
              <td>{treasurer_report.file_url &&
                <a href={treasurer_report.file_url} target="_blank" className="fw-bold" id={treasurer_report.id}>View</a>}
              </td>
          </tr>
      );
      return(
          <>
          <div className="row">
              <div className="col-lg-12 col-md-12 col-xs-12">
                  <div className="card shadow mb-4">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-white">Treasurer Report</h4>
                      </div>
                      <div className="card-body">
                          <div className="table-responsive newsletter-form">
                              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                  <thead>
                                      <tr>
                                          <th role="button" onClick={() => this.handleSort('created_date')} >
                                            Created On {this.state.sortColumn === 'created_date' ? (this.state.sortDirection === 'asc' ? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-down" viewBox="0 0 16 16">
                                              <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
                                            </svg>
                                            :((this.state.sortDirection === 'desc')? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-up" viewBox="0 0 16 16">
                                              <path d="M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.5.5 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
                                            </svg>
                                            :<i class="fas fa-sort" style={{color: '#008435'}}></i>)):<i class="fas fa-sort" style={{color: '#008435'}}></i>}
                                          </th>
                                          <th role="button" onClick={() => this.handleSort('title')} >
                                            Title {this.state.sortColumn === 'title' ? (this.state.sortDirection === 'asc' ? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-down" viewBox="0 0 16 16">
                                              <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
                                            </svg>
                                            :((this.state.sortDirection === 'desc')? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-up" viewBox="0 0 16 16">
                                              <path d="M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.5.5 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
                                            </svg>
                                            :<i class="fas fa-sort" style={{color: '#008435'}}></i>)):<i class="fas fa-sort" style={{color: '#008435'}}></i>}
                                          </th>
                                          <th role="button" onClick={() => this.handleSort('posted_by')} >
                                            Posted By {this.state.sortColumn === 'posted_by' ? (this.state.sortDirection === 'asc' ? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-down" viewBox="0 0 16 16">
                                              <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
                                            </svg> 
                                            :((this.state.sortDirection === 'desc')? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-up" viewBox="0 0 16 16">
                                              <path d="M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.5.5 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
                                            </svg>
                                            :<i class="fas fa-sort" style={{color: '#008435'}}></i>)):<i class="fas fa-sort" style={{color: '#008435'}}></i>}
                                          </th>
                                          <th></th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {treasurer_reports_list}
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          </>
      );
    }
    else{
      return(
        <Loading message={""}/>
      )
    }
  }
}

function TreasurerReport() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <TreasurerReportList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { TreasurerReport };